module.exports = __webpack_public_path__ + "static/media/sort-desc.61e451be.svg";